import { Modal, Skeleton, Empty, Popconfirm } from "antd"
import { InboxOutlined, DeleteOutlined } from "@ant-design/icons"
import { useState, useEffect } from "react"
import Dragger from "antd/es/upload/Dragger"
import { PaperClipOutlined } from "@ant-design/icons"
import { useGetClientDocumentsMutation, useAddClientDocumentsMutation, useDeleteClientDocumentMutation } from "./crmDataApiSlice"
import { useDispatch } from "react-redux"
import { showSpinner, hideSpinner } from "../../../components/componentSlice"
import { message } from "antd"

import "./ClientDocument.css"

const ClientDocument = ({ client, openModal, handleModalOpen }) => {
    const [documents, setDocuments] = useState([])
    const [newDocuments, setNewDocuments] = useState([])
    const [errorMessage, setErrorMessage] = useState(null)

    const [getClientDocuments, {isLoading: isGetClientDocumentsLoading}] = useGetClientDocumentsMutation()
    const [addClientDocuments, {isLoading: isAddClientDocumentsLoading}] = useAddClientDocumentsMutation()
    const [deleteClientDocument, {isLoading: isDeleteClientDocumentLoading}] = useDeleteClientDocumentMutation()

    const dispatch = useDispatch()
    const [messageApi, contextHolder] = message.useMessage()

    useEffect(() => {
        if (isAddClientDocumentsLoading || isDeleteClientDocumentLoading) {
            dispatch(showSpinner())
        } else {
            dispatch(hideSpinner())
        }
    }, [isAddClientDocumentsLoading, isDeleteClientDocumentLoading])

    useEffect(() => {
        async function handleGetDocuments(clientId) {
            try {
                const response = await getClientDocuments(clientId).unwrap()
                if(response) {
                    setDocuments(response)
                }
            } catch(err) {
                setErrorMessage(err.data?.detail)
            }
        }

        if(client?.clientId) {
            handleGetDocuments(client.clientId)
        }
    }, [client, openModal])

    const showSuccessfulAlert = (message) => {
        messageApi.success(message)
    }

    useEffect(() => {
        setNewDocuments([])
    }, [client, openModal])

    const getDocumentList = () => {
        return documents?.length > 0 ?
            <div className="documents-container">
                <div className="downloadable-links">
                    {
                        documents.map((document) => {
                            return (
                                <div className="document-row">
                                    <div className="document-row-item">
                                        <a href={document.link} target='_blank'>
                                            <button className="download-link">
                                                <PaperClipOutlined /><p>{`${document.fileName}`}</p>
                                            </button>
                                        </a>
                                    </div>
                                    <div className="document-row-item">
                                        <Popconfirm
                                            title="Delete"
                                            description={`Are you sure to delete this document?`}
                                            onConfirm={() => handleDeleteClientDocument(document.fileName)}
                                            okText="Yes"
                                            cancelText="No"
                                        >
                                            <button className="document-delete-btn"><DeleteOutlined /></button>
                                        </Popconfirm>
                                        
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        :
            <div className="no-file">
                <Empty description="Client has no documents yet." />
            </div>
    }

    const uploadClientDocuments = async () => {
        setErrorMessage("")
        if(!client.clientId) {
            return
        }

        try {
            await addClientDocuments({
                clientId: client.clientId,
                documents: newDocuments
            }).unwrap()

            showSuccessfulAlert("Document Uploaded")
            addNewDocuments(newDocuments)
            setNewDocuments([])
        } catch(err) {
            if(!err.status || err.status === "FETCH_ERROR") {
                setErrorMessage("No Server Response")
            } else {
                setErrorMessage(err.data?.detail)
            }
        }
    }

    const handleDeleteClientDocument = async (document) => {
        setErrorMessage("")
        if(!client.clientId) {
            return
        }

        try {
            await deleteClientDocument({
                clientId: client.clientId,
                document: document
            }).unwrap()

            showSuccessfulAlert("Document Deleted")
            removeDocument(document)
        } catch(err) {
            if(!err.status || err.status === "FETCH_ERROR") {
                setErrorMessage("No Server Response")
            } else {
                setErrorMessage(err.data?.detail)
            }
        }
    }

    const addNewDocuments = (docs) => {
        let newDocuments = docs.map(doc => {
            return {
                link: URL.createObjectURL(doc.originFileObj),
                fileName: doc.originFileObj.name
            }
        })

        setDocuments((prev) => [...prev, ...newDocuments])
    }

    const removeDocument = (document) => {
        let updatedDocuments = documents.filter(doc => doc.fileName !== document)

        setDocuments(updatedDocuments)
    }

    return (
        <Modal className="client-document-modal" width="100%" open={openModal} onCancel={() => handleModalOpen(false)} footer={[]}>
            <div>
                {contextHolder}
                <div className='top-header'>
                    <header>{`${client?.firstName}'s Documents`}</header>
                </div>
                {errorMessage &&
                    <div className="support-error">
                        <p>{errorMessage}</p>
                    </div>
                }
                {isGetClientDocumentsLoading ? <Skeleton active /> : getDocumentList()}
                
                <div className="add-documents-container">
                    <div><h3 className="header">Upload Documents</h3></div>
                    <Dragger
                        className="client-document-dragger"
                        beforeUpload={(file) => {
                            const isPdf = file.type === 'application/pdf'
                            // if (!isPdf) {
                            //     showErrorAlert("Additional files can only be PDFs.")
                            // }
                            return false
                        }}
                        fileList={newDocuments}
                        accept=".pdf"
                        onChange={(info) => setNewDocuments(info.fileList)}>
                        <p className="ant-upload-drag-icon"><InboxOutlined /></p>
                        <p className="ant-upload-text">Click or drag file to this area to upload</p>
                    </Dragger>
                    
                    <div className="upload-button-container">
                        <div className="form-group">
                            <button className="crm-button" disabled={!newDocuments || newDocuments.length < 1} onClick={() => uploadClientDocuments()}>Upload</button>
                        </div>
                    </div>
                    
                </div>
            </div>
        </Modal>
    )
}

export default ClientDocument